<template>
  <van-popup v-model="show" round position="bottom" :style="{ height: '80%' }">
    <div class="content-wrap">
      <div class="title">{{ detail.title }}</div>
      <div class="sub-title">{{ detail.subTitle }}</div>
      <div class="time">{{ detail.flightDate && detail.flightDate.split(" ")[0] }}</div>
      <div class="content-title" v-if="detail.eventContent">
        <div class="left-line"></div>
        <div class="title-name">事件描述</div>
        <div class="right-line"></div>
      </div>
      <div class="content" v-if="detail.eventContent" v-html="detail.eventContent"></div>
      <div class="content-title" v-if="detail.causeAnalysis">
        <div class="left-line"></div>
        <div class="title-name">原因分析</div>
        <div class="right-line"></div>
      </div>
      <div class="content" v-if="detail.causeAnalysis" v-html="detail.causeAnalysis"></div>
      <div class="content-title" v-if="detail.dealContent">
        <div class="left-line"></div>
        <div class="title-name">处置描述</div>
        <div class="right-line"></div>
      </div>
      <div class="content" v-if="detail.dealContent" v-html="detail.dealContent"></div>
    </div>
  </van-popup>
</template>

<script>
import {getHistoryToday} from "@/pages/Integral/api";

export default {
  name: "index",
  data() {
    return {
      show: false,
      detail: {}
    }
  },
  created() {
    this.getToday()
  },
  methods: {
    async getToday() {
      const res = await getHistoryToday({})
      if (res?.code !== 200) return
      if (res.data.id) {
        this.show = true
        this.detail = res.data
      }
    },
  }
}
</script>

<style scoped lang="scss">
.content-wrap {
  padding: 0.2rem;
  flex: 1;

  .title {
    font-size: 0.22rem;
    color: #333333;
    line-height: 0.3rem;
    padding-bottom: 0.12rem;
  }

  .sub-title {
    font-size: 0.14rem;
    color: #999999;
    line-height: 0.2rem;
  }

  .time {
    font-size: 0.14rem;
    color: #666666;
    line-height: 0.2rem;
  }

  .content-title {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.32rem 0 0.1rem;

    .left-line {
      width: 0.97rem;
      border: 1px solid;
      border-image: linear-gradient(90deg, rgba(200, 200, 200, 0), rgba(151, 151, 151, 0.48)) 1 1;
    }

    .title-name {
      font-size: 0.18rem;
      color: #164FA6;
      line-height: 0.25rem;
      padding: 0 0.08rem;
    }

    .right-line {
      width: 0.97rem;
      border: 1px solid;
      border-image: linear-gradient(270deg, rgba(200, 200, 200, 0), rgba(151, 151, 151, 0.48)) 1 1;
    }
  }

  .content {
    padding: 0.13rem 0.2rem;
    background: #F8F8F8;
    border-radius: 0.08rem;
    font-size: 0.14rem;
    color: #333333;
    line-height: 0.24rem;
  }
}

</style>
